import { useEffect, useState } from "react";
import {
  Container,
  Center,
  Loader,
  Group,
  TextInput,
  ActionIcon,
  Text,
  Button,
  Paper,
  Stack,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { createEnvironment, getEnvironments, deleteEnvironment } from "../api";
import { IconTrash } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";

export default function Environments() {
  const [environments, setEnvironments] = useState(null);

  useEffect(() => {
    getEnvironments().then((data) => {
      setEnvironments(data);
    });
  }, []);

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {},
    validate: {
      name: (val) =>
        /^[a-z0-9_]{2,49}[a-z0-9]$/.test(val)
          ? null
          : "Name must only contain lowercase letters, digits, and underscores, and be between 3 and 50 characters long",
    },
  });

  if (!environments)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  return (
    <Container size="xs" px={0}>
      {environments.map((item) => (
        <Paper mb="md" key={item.name}>
          <Group>
            <Text fw={500}>{item.name}</Text>
            <ActionIcon
              color="red"
              onClick={() =>
                deleteEnvironment(item.id).then(() =>
                  setEnvironments(environments.filter((p) => p.id != item.id))
                )
              }
            >
              <IconTrash />
            </ActionIcon>
          </Group>
          <Text>
            <Stack>
              {item.activeVersions?.map((version) => (
                <Text key={`env_${item.name}_${version.versionId}`}>
                  {version.flowName} - {version.versionId} - TBD link{" "}
                  {version.flowId}
                </Text>
              ))}
            </Stack>
          </Text>
        </Paper>
      ))}

      <form
        onSubmit={form.onSubmit((values) =>
          createEnvironment(values).then((newEnv) => {
            setEnvironments([...environments, newEnv]);
            notifications.show({
              title: "Environment created.",
              color: "green",
            });
            form.setFieldValue("name", "");
          })
        )}
      >
        <Group>
          <TextInput
            placeholder="production"
            withAsterisk
            style={{ flex: 1 }}
            key={form.key(`name`)}
            {...form.getInputProps(`name`)}
          />

          <Button type="submit">Create</Button>
        </Group>
      </form>
    </Container>
  );
}
